import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './CookieBanner.module.css';

const STORAGE_KEY = 'jbp_cookie_notice_ack_v1';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const handleAcknowledge = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore storage errors; banner will just reappear next visit
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="region" aria-label={t('cookieBanner.ariaLabel')}>
      <p className={styles.text}>
        {t('cookieBanner.message')}{' '}
        <Link to="/privacy-policy" state={{ scrollTo: 'cookies' }} className={styles.link}>
          {t('cookieBanner.learnMore')}
        </Link>
      </p>
      <button className={styles.button} onClick={handleAcknowledge}>
        {t('cookieBanner.acknowledge')}
      </button>
    </div>
  );
};

export default CookieBanner;
